import React from 'react';
import HdIcon from '../../../../media/components/icon/HdIcon';
import styles from './styles.module.scss';

function ActivationStatsShimmer() {
  return (
    <>
      <div className="center-flex-row mb-5">
        <div className="box p-5 d-flex flex-2">
          <div className="flex-col justify-between flex-1">
            <div className="center-flex-row">
              <span className="shimmer shimmer-circle" style={{ width: '10px', height: '10px' }} />
              <span className="shimmer shimmer-line ml-1" style={{ width: '51px', height: '10px' }} />
            </div>

            <div className="d-flex align-items-end justify-between mt-4">
              <span className="shimmer shimmer-line ml-1" style={{ width: '31px', height: '9px' }} />
              <span className="shimmer shimmer-line mt-4" style={{ width: '212px', height: '14px' }} />
            </div>
          </div>

          <HdIcon
            name="right-arrow"
            className={styles.statsArrow}
            size="4"
          />

          <div className="flex-col justify-between flex-1">
            <div className="center-flex-row">
              <span className="shimmer shimmer-circle" style={{ width: '10px', height: '10px' }} />
              <span className="shimmer shimmer-line ml-1" style={{ width: '51px', height: '10px' }} />
            </div>

            <div className="d-flex align-items-end justify-between mt-4">
              <span className="shimmer shimmer-line ml-1" style={{ width: '31px', height: '9px' }} />
              <span className="shimmer shimmer-line mt-4" style={{ width: '212px', height: '14px' }} />
            </div>
          </div>
        </div>

        <HdIcon
          name="right-arrow"
          className={styles.statsArrow}
          size="4"
        />

        <div className="box p-5 flex-1">
          <div className="flex-col justify-between">
            <div className="center-flex-row">
              <span className="shimmer shimmer-circle" style={{ width: '10px', height: '10px' }} />
              <span className="shimmer shimmer-line ml-1" style={{ width: '51px', height: '10px' }} />
            </div>

            <div className="d-flex align-items-end justify-between mt-4">
              <span className="shimmer shimmer-line ml-1" style={{ width: '31px', height: '9px' }} />
              <span className="shimmer shimmer-line mt-4" style={{ width: '212px', height: '14px' }} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActivationStatsShimmer;
